<template>
  <Stack align="center" gap="xs">
    <Checkbox
      id="select-all-checkbox"
      :model-value="isSelected"
      :value="true"
      name="select-all"
      label="Select all"
      :label-visible="false"
      :indeterminate="props.indeterminate"
      @update:model-value="toggleSelected"
    />
    <Stack direction="col" gap="xs" class="relative" v-on-click-outside="closeDropdown">
      <Stack align="center" justify="center" class="p-2xs cursor-pointer" @click="toggleDropdown">
        <span :class="['transition-transform duration-200', isExpanded && 'rotate-180']">
          <Icon name="triangle-down" :size="16" />
        </span>
      </Stack>
      <Dropdown :active="isExpanded" class="!w-[140px] absolute z-50 !shadow-all-sm mt-lg">
        <aside class="w-full bg-white py-2xs">
          <nav>
            <ul>
              <li class="h-full w-full bg-white hover:bg-grey-default" @click="toggleDropdown">
                <Stack tag="button" class="block w-full h-full px-sm py-[12px]" @click="setSelectAll(true)">
                  <Text tag="span" weight="semi" align="left">All</Text>
                </Stack>
              </li>
              <li class="h-full w-full bg-white hover:bg-grey-default" @click="toggleDropdown">
                <Stack tag="button" class="block w-full h-full px-sm py-[12px]" @click="setSelectAll(false)">
                  <Text tag="span" weight="semi" align="left">None</Text>
                </Stack>
              </li>
              <li class="h-full w-full bg-white hover:bg-grey-default" @click="toggleDropdown">
                <Stack tag="button" class="block w-full h-full px-sm py-[12px]" @click="selectPaid">
                  <Text tag="span" weight="semi" align="left">Paid</Text>
                </Stack>
              </li>
              <li class="h-full w-full bg-white hover:bg-grey-default" @click="toggleDropdown">
                <Stack tag="button" class="block w-full h-full px-sm py-[12px]" @click="selectUnpaid">
                  <Text tag="span" weight="semi" align="left">Unpaid</Text>
                </Stack>
              </li>
            </ul>
          </nav>
        </aside>
      </Dropdown>
    </Stack>
  </Stack>
</template>

<script lang="ts" setup>
import { InvoicesSelectorProps } from "./invoicesSelectorTypes";
import { vOnClickOutside } from "@vueuse/components";

const props = defineProps<InvoicesSelectorProps>();

const emit = defineEmits<{
  (event: "select:all", value: boolean): void;
  (event: "select:paid"): void;
  (event: "select:unpaid"): void;
}>();

const isSelected = ref<boolean>(props.selected);
const isExpanded = ref<boolean>(false);

const toggleDropdown = () => (isExpanded.value = !isExpanded.value);

const closeDropdown = () => (isExpanded.value = false);

const toggleSelected = (): void => {
  isSelected.value = !isSelected.value;
  emit("select:all", isSelected.value);
};

const setSelectAll = (value: boolean): void => {
  isSelected.value = value;
  emit("select:all", isSelected.value);
};

const selectPaid = (): void => {
  isSelected.value = true;
  emit("select:paid");
};

const selectUnpaid = (): void => {
  isSelected.value = true;
  emit("select:unpaid");
};

watch(
  () => props.selected,
  (value) => {
    isSelected.value = value;
  },
);
</script>
